var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-b-6",attrs:{"id":'jump-' + _vm.index}},[_c('div',{staticClass:"slat-group-content"},[(_vm.heading)?_c('h2',{staticClass:"f-s-7 c-primary m-b-4"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('course-content',{attrs:{"modules":_vm.modules}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }